// Lucide icon: circle-dollar-sign (https://lucide.dev/icons/circle-dollar-sign)
import { CircleDollarSign } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconPayment = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <CircleDollarSign />
    </IconComponentStyled>
  )
}
